<template>
  <div class="main supervision-main">
    <statics-card type="prescription" ref="staticsCard"></statics-card>
    <el-card>
      <prescription-search-bar
        :search-params="searchParams"
        :store-id="storeId"
        @changeSearchParams="changeSearchParams"
        :correctionTypeCodeMap="correctionTypeCodeMap"
        @search="search"
      />
      <prescription-list :data="list" @update="updateItem" :correctionTypeCodeMap="correctionTypeCodeMap" />
      <pagination
        @handlePage="handlePage"
        v-if="list && list.length"
        :total="total"
        :current-page="pageNo"
        :page-size="pageSize"
      />
    </el-card>
  </div>
</template>

<script>
import Fetch from '@/api';
import { mapGetters } from 'vuex';
import dayjs from 'dayjs';
import staticsCard from './components/staticsCard';
import prescriptionSearchBar from './components/prescriptionSearchBar';
import prescriptionList from './components/prescriptionList';
import pagination from './components/pagination';
import { mapRequestParamsEmpty2Null } from '@/util';

const type2Datetime = type => {
  switch (type) {
    case 'today': {
      return {
        orderStartTime: dayjs().startOf('day').format('YYYY-MM-DD HH:mm:ss'),
        orderEndTime: dayjs().endOf('day').format('YYYY-MM-DD HH:mm:ss')
      };
    }
    case 'yesterday': {
      const yesterday = dayjs().subtract(1, 'days');
      return {
        orderStartTime: yesterday.startOf('day').format('YYYY-MM-DD HH:mm:ss'),
        orderEndTime: yesterday.endOf('day').format('YYYY-MM-DD HH:mm:ss')
      };
    }
    case 'week':
      return {
        orderStartTime: dayjs().startOf('isoWeek').format('YYYY-MM-DD HH:mm:ss'),
        orderEndTime: dayjs().endOf('isoWeek').format('YYYY-MM-DD HH:mm:ss')
      };
    case 'month':
      return {
        orderStartTime: dayjs().startOf('month').format('YYYY-MM-DD HH:mm:ss'),
        orderEndTime: dayjs().endOf('month').format('YYYY-MM-DD HH:mm:ss')
      };
    case 'year':
      return {
        orderStartTime: dayjs().startOf('year').format('YYYY-MM-DD HH:mm:ss'),
        orderEndTime: dayjs().endOf('year').format('YYYY-MM-DD HH:mm:ss')
      };
    default:
      return {
        orderStartTime: dayjs().startOf('isoWeek').format('YYYY-MM-DD HH:mm:ss'),
        orderEndTime: dayjs().endOf('isoWeek').format('YYYY-MM-DD HH:mm:ss')
      };
  }
};

const today = type2Datetime('today');

export default {
  name: 'orderList',
  components: { staticsCard, prescriptionSearchBar, prescriptionList, pagination },
  data() {
    return {
      searchParams: {
        drugName: '',
        orderId: '',
        prescriptionStatus: null,
        patchedStatus: null,
        prescriptionCategory: null,
        correctionTypeCode: null,
        isCorrection: null,
        dateRange: [today.orderStartTime, today.orderEndTime]
      },
      list: [],
      pageNo: 1,
      pageSize: 10,
      total: 0,
      correctionTypeCodeMap: {}
    };
  },
  computed: {
    ...mapGetters(['storeList']),
    storeId() {
      // 多店业务上暂时不考虑
      const { storeList } = this;
      return Array.isArray(storeList) ? storeList?.[0].id : storeList?.id;
    }
  },
  mounted() {
    this.initParams();
    this.init();
    this.initType();
  },
  methods: {
    initType() {
      const { storeId } = this;
      Fetch.getCorrectionTypeCode({ storeId, classify: 3 }).then(res => {
        res.map(item => {
          // this.correctionTypeCode[item.correctionTypeCodeCode] = item.correctionTypeCodeDesc;
          this.$set(this.correctionTypeCodeMap, item.correctionTypeCode, item.correctionTypeDesc);
        });
      });
    },
    initParams() {
      const { drugName, orderId, messageTime } = this.$route.query;
      if (drugName) {
        this.searchParams.drugName = drugName;
        this.searchParams.dateRange = [];
      }

      if (orderId) {
        this.searchParams.orderId = orderId;
        this.searchParams.dateRange = [];
      }
      if (messageTime) {
        const startTime = dayjs(Number(messageTime)).format('YYYY-MM-DD 00:00:00');
        const endTime = dayjs(Number(messageTime)).format('YYYY-MM-DD 23:59:59');
        this.searchParams.dateRange = [startTime, endTime];
      }
    },
    init() {
      const { pageSize } = this;
      const { dateRange } = this.searchParams;
      const [orderStartTime, orderEndTime] = dateRange || [];
      this.fetchList({ ...this.searchParams, orderStartTime, orderEndTime, pageNo: 1, pageSize });
    },
    handlePage(pageNo) {
      const { searchParams, pageSize } = this;
      const { dateRange, ...rest } = searchParams;
      const [orderStartTime, orderEndTime] = dateRange || [];
      this.fetchList({ ...rest, orderStartTime, orderEndTime, pageNo, pageSize });
    },
    search() {
      const { searchParams, pageSize } = this;
      const { dateRange, ...rest } = searchParams;
      const [orderStartTime, orderEndTime] = dateRange || [];
      this.fetchList({ ...rest, orderStartTime, orderEndTime, pageNo: 1, pageSize });
    },
    changeSearchParams({ key, value }) {
      this.searchParams[key] = value;
    },
    fetchList(params) {
      const { storeId } = this;
      return Fetch.getSupervisionPrescriptionOrderList(
        mapRequestParamsEmpty2Null({
          ...params,
          storeId
        })
      ).then(res => {
        const { pageNo, totalCount, data } = res;
        this.pageNo = pageNo;
        this.total = totalCount;
        this.list = data;
      });
    },
    updateItem() {
      if (this.$refs.staticsCard) this.$refs.staticsCard.fetchStaticsData();
      const { searchParams, pageSize, pageNo } = this;
      const { dateRange, ...rest } = searchParams;
      const [orderStartTime, orderEndTime] = dateRange || [];
      this.fetchList({ ...rest, orderStartTime, orderEndTime, pageNo, pageSize });
    }
  }
};
</script>

<style lang="scss" scoped></style>
